var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    [
      _c("li", [
        _c("h3", [_vm._v(_vm._s(_vm.t("health", "Column selection", {})))])
      ]),
      _vm._v(" "),
      _c(
        "ActionCheckbox",
        {
          attrs: { checked: _vm.person.weightColumnWeight },
          on: {
            change: function($event) {
              return _vm.$store.dispatch("setValue", {
                key: "weightColumnWeight",
                value: $event.target.checked
              })
            }
          }
        },
        [_vm._v("\n\t\t" + _vm._s(_vm.t("health", "Weight", {})) + "\n\t")]
      ),
      _vm._v(" "),
      _c(
        "ActionCheckbox",
        {
          attrs: { checked: _vm.person.weightColumnBmi },
          on: {
            change: function($event) {
              return _vm.$store.dispatch("setValue", {
                key: "weightColumnBmi",
                value: $event.target.checked
              })
            }
          }
        },
        [
          _vm._v(
            "\n\t\t" +
              _vm._s(_vm.t("health", "Boby mass index (BMI)", {})) +
              "\n\t"
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "ActionCheckbox",
        {
          attrs: { checked: _vm.person.weightColumnBodyfat },
          on: {
            change: function($event) {
              return _vm.$store.dispatch("setValue", {
                key: "weightColumnBodyfat",
                value: $event.target.checked
              })
            }
          }
        },
        [_vm._v("\n\t\t" + _vm._s(_vm.t("health", "Bodyfat", {})) + "\n\t")]
      ),
      _vm._v(" "),
      _c(
        "ActionCheckbox",
        {
          attrs: { checked: _vm.person.weightColumnMeasurement },
          on: {
            change: function($event) {
              return _vm.$store.dispatch("setValue", {
                key: "weightColumnMeasurement",
                value: $event.target.checked
              })
            }
          }
        },
        [
          _vm._v(
            "\n\t\t" +
              _vm._s(
                _vm.person.weightMeasurementName
                  ? _vm.person.weightMeasurementName
                  : _vm.t("health", "Custom measurement")
              ) +
              "\n\t"
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "ActionCheckbox",
        {
          attrs: { checked: _vm.person.weightColumnWaistSize },
          on: {
            change: function($event) {
              return _vm.$store.dispatch("setValue", {
                key: "weightColumnWaistSize",
                value: $event.target.checked
              })
            }
          }
        },
        [_vm._v("\n\t\t" + _vm._s(_vm.t("health", "Waist size", {})) + "\n\t")]
      ),
      _vm._v(" "),
      _c(
        "ActionCheckbox",
        {
          attrs: { checked: _vm.person.weightColumnHipSize },
          on: {
            change: function($event) {
              return _vm.$store.dispatch("setValue", {
                key: "weightColumnHipSize",
                value: $event.target.checked
              })
            }
          }
        },
        [_vm._v("\n\t\t" + _vm._s(_vm.t("health", "Hip size", {})) + "\n\t")]
      ),
      _vm._v(" "),
      _c(
        "ActionCheckbox",
        {
          attrs: { checked: _vm.person.weightColumnMusclePart },
          on: {
            change: function($event) {
              return _vm.$store.dispatch("setValue", {
                key: "weightColumnMusclePart",
                value: $event.target.checked
              })
            }
          }
        },
        [_vm._v("\n\t\t" + _vm._s(_vm.t("health", "Muscle part", {})) + "\n\t")]
      ),
      _vm._v(" "),
      _c("li", [
        _c("h3", [_vm._v(_vm._s(_vm.t("health", "General settings", {})))])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("h4", [_vm._v(_vm._s(_vm.t("health", "Unit for weight", {})))])
      ]),
      _vm._v(" "),
      _c("ActionInput", {
        attrs: {
          type: "text",
          value: _vm.person.weightUnit,
          icon: "icon-category-customization"
        },
        on: { submit: _vm.updateWeightUnit }
      }),
      _vm._v(" "),
      _c("li", [
        _c("h4", [
          _vm._v(
            "\n\t\t\t" + _vm._s(_vm.t("health", "Custom column name", {}))
          ),
          _c("span", [
            _c("br"),
            _vm._v(
              _vm._s(
                _vm.t(
                  "health",
                  "What else do you want to track? Set here a name and you can add data in the data-table. The values have to be numbers. Please do not forget to activate the column in the column selections.",
                  {}
                )
              )
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("ActionInput", {
        attrs: {
          type: "text",
          value: _vm.person.weightMeasurementName,
          icon: "icon-rename"
        },
        on: { submit: _vm.updateMeasurementName }
      }),
      _vm._v(" "),
      _c("li", [
        _c(
          "h3",
          {
            staticClass: "toggable",
            on: {
              click: function($event) {
                _vm.showTargetOptions = !_vm.showTargetOptions
              }
            }
          },
          [
            _vm._v(
              "\n\t\t\t" + _vm._s(_vm.t("health", "Target", {})) + "\n\t\t"
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _c("h4", [
          _vm._v(
            "\n\t\t\t" + _vm._s(_vm.t("health", "Weight target")) + "\n\t\t\t"
          ),
          _c("span", [
            _vm._v(
              "\n\t\t\t\t" +
                _vm._s(
                  _vm.t("health", "in {unit}", { unit: _vm.person.weightUnit })
                ) +
                "\n\t\t\t\t"
            ),
            _c("br"),
            _vm._v(
              "\n\t\t\t\t" +
                _vm._s(_vm.t("health", "Leave blank for none.")) +
                "\n\t\t\t"
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("ActionInput", {
        attrs: {
          type: "number",
          value: _vm.person.weightTarget,
          icon: "icon-category-monitoring"
        },
        on: { submit: _vm.updateWeightTarget }
      }),
      _vm._v(" "),
      _c("li", [
        _c("h4", [
          _vm._v(
            "\n\t\t\t" +
              _vm._s(_vm.t("health", "Weight target initial weight")) +
              "\n\t\t\t"
          ),
          _c("span", [
            _vm._v(
              "\n\t\t\t\t" +
                _vm._s(
                  _vm.t("health", "in {unit}", { unit: _vm.person.weightUnit })
                ) +
                "\n\t\t\t\t"
            ),
            _c("br"),
            _vm._v(
              "\n\t\t\t\t" +
                _vm._s(
                  _vm.t(
                    "health",
                    "This is your reference weight for the target"
                  )
                ) +
                "\n\t\t\t"
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("ActionInput", {
        attrs: {
          type: "number",
          value:
            _vm.person.weightTargetInitialWeight !== null
              ? _vm.person.weightTargetInitialWeight
              : "",
          icon: "icon-quota"
        },
        on: { submit: _vm.updateWeightTargetInitialWeight }
      }),
      _vm._v(" "),
      _c("li", [
        _c("h4", [
          _vm._v(
            "\n\t\t\t" +
              _vm._s(_vm.t("health", "Weight target bounty", {})) +
              "\n\t\t"
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "textarea-sidebar" }, [
        _c("textarea", {
          ref: "weightTargetBounty",
          attrs: {
            placeholder: _vm.t(
              "health",
              "Add some bounty to motivate yourself, if you like to.",
              {}
            )
          },
          domProps: { value: _vm.person.weightTargetBounty }
        })
      ]),
      _vm._v(" "),
      _c("button", { on: { click: _vm.updateWeightTargetBounty } }, [
        _vm._v("\n\t\t" + _vm._s(_vm.t("health", "Save bounty", {})) + "\n\t")
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }